/*
  List of discount codes that can be returned from split that are whitelisted. 
  If we get one of these codes back from the split experiment config, that code would be considered a "default discount"
*/

export const experimentCodesWhitelist = new Set([
  'tfd20default',
  'tfddefault50',
]);
